import { MapMarkerModel } from './map-marker.model';

export function toMapMarkerModel(apiData: any): MapMarkerModel {
  let type = apiData.type?.toLowerCase();
  if (type === 'company') {
    type = 'organization';
  }

  let profile_image = apiData.profile_image;
  if (!profile_image || profile_image.trim() === '') {
    if (type === 'space' || type === 'organization') {
      profile_image = './assets/images/team-profile-picture.jpg';
    }
  }

  return {
    id: apiData.id,
    type,
    name: apiData.name,
    latitude: apiData.latitude !== undefined ? Number(apiData.latitude) : null,
    longitude: apiData.longitude !== undefined ? Number(apiData.longitude) : null,
    profile_image
  };
}
